"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposedHttpAuthenticationProvider = void 0;
var ComposedHttpAuthenticationProvider = /** @class */ (function () {
    function ComposedHttpAuthenticationProvider(authenticationProviders) {
        this.authenticationProviders = authenticationProviders;
    }
    ComposedHttpAuthenticationProvider.prototype.setAuthenticationData = function (config) {
        for (var _i = 0, _a = this.authenticationProviders; _i < _a.length; _i++) {
            var authenticationProvider = _a[_i];
            authenticationProvider.setAuthenticationData(config);
        }
    };
    return ComposedHttpAuthenticationProvider;
}());
exports.ComposedHttpAuthenticationProvider = ComposedHttpAuthenticationProvider;
